import { useTranslation } from 'react-i18next'

export function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="bg-foreground py-4">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row md:justify-between">
          <p className="text-sm text-background mb-2 md:mb-0">
            {new Date().getFullYear()}{' '}
            {t('footer.bloomwell', { defaultValue: 'Bloomwell GmbH' })}
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <a
              href="https://bloomwell.de/impressum"
              target="_blank"
              rel="noopener noreferrer"
              className="text-background hover:text-background/80"
            >
              {t('footer.impressum', { defaultValue: 'Impressum' })}
            </a>
            <a
              href="https://bloomwell.de/datenschutz"
              target="_blank"
              rel="noopener noreferrer"
              className="text-background hover:text-background/80"
            >
              {t('footer.privacy', { defaultValue: 'Datenschutzerklärung' })}
            </a>
            <a
              href="https://bloomwell.de/nutzungsbedingungen"
              target="_blank"
              rel="noopener noreferrer"
              className="text-background hover:text-background/80"
            >
              {t('footer.terms', { defaultValue: 'Nutzungsbedingungen' })}
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
